export default {"src":"/_next/static/media/TherapistSearchIllustration.17140fab.svg","height":104,"width":150,"blurWidth":0,"blurHeight":0};